export const css = (strings: TemplateStringsArray, ...values: unknown[]): string => {
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  return strings.raw.reduce((acc, str, i) => acc + str + (values[i] || "").toString(), "");
};
